import { configureStore } from "@reduxjs/toolkit";
import { combineReducers } from "redux";
import { persistReducer, persistStore } from "redux-persist";
import storage from "redux-persist/lib/storage";

import sarvahReducer from "./pages/home/reducer/slice.js";

const appReducer = combineReducers({
  sarvah: sarvahReducer,
});

const rootReducer = (state, action) => {
  return appReducer(state, action);
};

const persistConfig = {
  key: "root",
  storage: storage,
  whitelist: ["hierarchy"],
};

const store = configureStore({
  reducer: appReducer,
  devTools: true,
});
const persistor = persistStore(store);

// export default { store, persistor };
export default store;
